import tooltip from 'tooltip.js';

/**
 * Tooltip module implementation.
 *
 * @author Daniel Koch (https://danielkoch.de)
 * @namespace Tc.Module
 * @class Tooltip
 * @extends Tc.Module
 */
T.Module.Tooltip = T.createModule({
	_attributes: {},
	_configs: {},
	_selectors: {
		tooltipTrigger: '[data-js-a-tooltip-trigger]',
		tooltipContent: '[data-js-a-tooltip-content]',
	},
	_eventNames: {
		CLICK: 'click',
	},
	_stateClasses: {},

	start: function(resolve) {
		this.$ctx = $(this._ctx);

		const $tooltipTrigger = this.$ctx.find(this._selectors.tooltipTrigger),
			tooltipContent = this.$ctx.find(this._selectors.tooltipContent).html();

		/* eslint-disable-next-line */
		new tooltip($tooltipTrigger, {
			template: '<div class="tooltip" role="tooltip"><div class="tooltip__inner"></div></div>', // eslint-disable-line max-len
			placement: 'top', // or bottom, left, right, and variations
			title: tooltipContent,
			trigger: 'hover',
			offset: '0, 30px, 0, 0',
			html: true,
		});

		resolve();
	},
	sync() {
		// Called when start() method of all registered modules was called.
	},
});

export default T.Module.Tooltip;
